import { render, staticRenderFns } from "./EventCardOld.vue?vue&type=template&id=d637d588&scoped=true"
import script from "./EventCardOld.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventCardOld.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventCardOld.vue?vue&type=style&index=0&id=d637d588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d637d588",
  null
  
)

export default component.exports